(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buddy-commerce"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.BuddyCart) return;
  const config = JSON.parse(document.getElementById('BuddyCommerceConfig')?.textContent || '{}');
  const parse = html => new DOMParser().parseFromString(html, 'text/html');
  const commerce = window.BuddyCart = {
    config, busy: false, uncertain: false,
    sections() { return ['cart-drawer','cart-icon-bubble',document.querySelector('buddy-cart-page')?.dataset.sectionId].filter(Boolean); },
    lock(value) {
      this.busy = value;
      document.querySelectorAll('.bc-checkout,[data-bc-step],[data-bc-quantity]').forEach(n => n.disabled = value || this.uncertain);
      document.querySelectorAll('buddy-cart-page,.bc-drawer').forEach(n => n.setAttribute('aria-busy', String(value)));
      if(this.uncertain)document.querySelectorAll('[data-bc-error]').forEach(n=>{n.textContent=config.error;const a=document.createElement('a');a.href=window.routes.cart_url;a.textContent=' '+config.reload;n.append(a);});
    },
    render(sections) {
      const replacements = [];
      const noteValue=document.getElementById('BuddyCartNote')?.value;
      const page = document.querySelector('buddy-cart-page');
      if(page) { const source=parse(sections[page.dataset.sectionId] || '').querySelector('buddy-cart-page'); if(!source) throw new Error(config.error); replacements.push([page,source]); }
      const drawer = document.querySelector('cart-drawer.bc-drawer');
      if(drawer) {const source=parse(sections['cart-drawer'] || '').querySelector('#CartDrawer');if(!source) throw new Error(config.error);replacements.push([drawer.querySelector('#CartDrawer'),source]);}
      for(const [target,source] of replacements){target.innerHTML=source.innerHTML;if(target===page){page.dataset.count=source.dataset.count;page.observeSummary();}}
      if(noteValue!==undefined&&document.getElementById('BuddyCartNote'))document.getElementById('BuddyCartNote').value=noteValue;
      const icon=document.getElementById('cart-icon-bubble');
      if(icon && sections['cart-icon-bubble']) icon.innerHTML=parse(sections['cart-icon-bubble']).querySelector('.shopify-section').innerHTML;
      const count = page?.dataset.count ?? parse(sections['cart-icon-bubble'] || '').querySelector('[data-bc-count]')?.textContent;
      if(count !== undefined) document.querySelectorAll('[data-bc-count]').forEach(n=>n.textContent=count);
      this.lock(this.busy);
    },
    async refresh(){
      const url=new URL(window.routes.cart_url,location.origin);url.searchParams.set('sections',this.sections().join(','));
      const response=await fetch(url,{signal:AbortSignal.timeout(15000),headers:{Accept:'application/json'},cache:'no-store'});
      if(!response.ok)throw new Error(config.error);this.render(await response.json());
    },
    async change(root,key,quantity,focusAction){
      if(this.busy || this.uncertain)return;
      this.lock(true);root.querySelector('[data-bc-error]').textContent='';
      let errorMessage='';
      try{
        const response=await fetch(window.routes.cart_change_url+'.js',{method:'POST',signal:AbortSignal.timeout(15000),headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity,sections:this.sections(),sections_url:location.pathname})});
        const result=await response.json();
        if(!response.ok || result.errors)throw new Error(result.description || result.message || result.errors || config.error);
        this.render(result.sections);
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined') Promise.resolve(publish(PUB_SUB_EVENTS.cartUpdate,{source:'buddy-cart',cartData:result})).catch(()=>{});
        document.getElementById('BuddyCartStatus').textContent=config.updated;
      }catch(error){
        errorMessage=error.message || config.error;
        try{await this.refresh();}catch{this.uncertain=true;errorMessage=config.error;}
      }finally{
        this.lock(false);
        const error=root.querySelector('[data-bc-error]');error.textContent=errorMessage;
        if(errorMessage){if(this.uncertain){const reload=document.createElement('a');reload.href=window.routes.cart_url;reload.textContent=' '+config.reload;error.append(reload);}error.focus();}
        else {const row=[...root.querySelectorAll('[data-line-key]')].find(n=>n.dataset.lineKey===key);(row?.querySelector(focusAction) || root.querySelector('h1,h2'))?.focus({preventScroll:true});}
      }
    }
  };
  function bind(root){
    root.addEventListener('click',e=>{
      const step=e.target.closest('[data-bc-step]'),remove=e.target.closest('[data-bc-remove]');if(!step&&!remove)return;
      e.preventDefault();if(commerce.busy)return;const row=(step||remove).closest('[data-line-key]'),input=row.querySelector('[data-bc-quantity]');
      let qty=0;if(step){const inc=Number(input.step)||1,min=Number(input.dataset.min)||1;qty=Number(input.value)+Number(step.dataset.bcStep)*inc;if(qty<min)qty=step.dataset.bcStep==='-1'?0:min;if(input.max&&qty>Number(input.max))return;}
      commerce.change(root,row.dataset.lineKey,qty,step?`[data-bc-step="${step.dataset.bcStep}"]`:'[data-bc-remove]');
    });
    root.addEventListener('change',e=>{
      if(!e.target.matches('[data-bc-quantity]'))return;const input=e.target,qty=Number(input.value),min=Number(input.dataset.min)||1,step=Number(input.step)||1;
      if(input.value===''||!Number.isInteger(qty)||qty<0||(qty!==0&&(qty<min||qty%step!==0))||!input.checkValidity()){input.reportValidity();input.value=input.dataset.original;return;}
      commerce.change(root,input.closest('[data-line-key]').dataset.lineKey,qty,'[data-bc-quantity]');
    });
  }
  commerce.bind=bind;
  customElements.define('buddy-cart-page',class extends HTMLElement{
    connectedCallback(){if(!this.bound){bind(this);this.bound=true;}this.observeSummary();}
    disconnectedCallback(){this.observer?.disconnect();}
    observeSummary(){this.observer?.disconnect();const summary=this.querySelector('.bc-checkout-wrap');if(!summary){this.removeAttribute('data-sticky-visible');return;}this.observer=new IntersectionObserver(([entry])=>this.toggleAttribute('data-sticky-visible',entry.intersectionRatio<1),{threshold:1});this.observer.observe(summary);}
  });
  document.addEventListener('submit',e=>{
    if(!e.submitter?.matches('.bc-checkout'))return;
    if(commerce.busy||commerce.uncertain){e.preventDefault();return;}
    e.submitter.querySelector('span').textContent=config.opening;e.submitter.setAttribute('aria-busy','true');
  });
  document.addEventListener('visibilitychange',()=>{if(!document.hidden&&!commerce.busy)commerce.refresh().catch(()=>{});});
  addEventListener('pageshow',e=>{if(e.persisted)location.reload();});
})();
  } catch(e) { console.error(e); }
})();

})();
